module.exports = __webpack_public_path__ + "img/38.b6aa1fd9.jpg";